import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMasterDataWithoutMarketplaceThunk, MasterDataStatus } from '@spike/masterdata-action';
import { cleanAll } from 'actions/ActionUtils';
import { RootState } from 'store';
import { isPublic as isPublicPath, requiresCleanUp } from 'routes/Paths';
import Routes from 'routes/Routes';
import ApiClient from 'api/ApiClient';
import Notifications from 'notifications';
import './App.css';

const App: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { status: masterDataStatus } = useSelector((state: RootState) => state.masterData);
    const { auth } = useSelector((state: RootState) => state.login);

    const isPublic = isPublicPath(location.pathname);
    const isAuthenticated = auth && auth.signedIn && auth.user && auth.token;
    const isMasterDataLoaded = masterDataStatus === MasterDataStatus.FetchSuccess;

    useEffect(() => {
        // Clean up state when navigating to paths that require cleanup
        if (requiresCleanUp(location.pathname)) {
            cleanAll(dispatch, true);
        }
    }, [dispatch, location.pathname]);

    useEffect(() => {
        // Fetch master data if user is authenticated and data is not loaded
        if (isAuthenticated && !isMasterDataLoaded && masterDataStatus !== MasterDataStatus.Fetching) {
            dispatch(fetchMasterDataWithoutMarketplaceThunk(ApiClient));
        }
    }, [dispatch, isAuthenticated, isMasterDataLoaded, masterDataStatus]);

    // Show loading for authenticated users while master data loads
    if (isAuthenticated && !isPublic && masterDataStatus === MasterDataStatus.Fetching) {
        return (
            <div className="app-loading">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <div className="app">
            <Notifications />
            <Routes />
        </div>
    );
};

export default App;
